import React from 'react';
import styled from 'styled-components';
import { Stream } from "@cloudflare/stream-react";

const Player = styled.div`
    position: relative;
    background-size: cover;
    z-index: 0;
    top: 10px;
    width: 100%;
    text-align: center;
    overflow: hidden;
    margin-bottom: 100px;
    @media (max-width: 1300px) {
        margin-top: 50px;
        margin-bottom: 10px;
    }
`;

const StyledVideo = styled.video.attrs(props => ({
    preload: "preload",
    autoPlay: "autoPlay",
    loop: "loop",
    muted: "muted",
    playsInline: "playsInline"
}))`
    margin: 0 auto;
    width: 85%;
    z-index: -100;
`;

const StyledStyled = styled(Stream)`
    margin: 0 auto;
    width: 85%;
    z-index: -100;
`;


class HeaderVideo extends React.Component {
    render() {
        const videoIdOrSignedToken = "f59efc3cc21de09046e152d1b7194884";
        return (
            <Player>
                {/*<StyledVideo>*/}
                {/*    <source src={videoMp4} type="video/mp4"/>*/}
                {/*    Your browser does not support HTML5 video.*/}
                {/*</StyledVideo>*/}
                <StyledStyled controls={false} autoplay={true} loop={true} muted={true} preload={true} src={videoIdOrSignedToken} />

            </Player>
        );
    }
}

export default HeaderVideo;